/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTenantPaymentGateways } from 'app/entities/tenant-payment-gateway/tenant-payment-gateway.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { TransactionCategory } from 'app/shared/model/enumerations/transaction-category.model';
import { createEntity, getEntity, reset, updateEntity } from './tenant-gateway-transaction.reducer';

export const TenantGatewayTransactionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tenantPaymentGateways = useAppSelector(state => state.tenantPaymentGateway.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const tenantGatewayTransactionEntity = useAppSelector(state => state.tenantGatewayTransaction.entity);
  const loading = useAppSelector(state => state.tenantGatewayTransaction.loading);
  const updating = useAppSelector(state => state.tenantGatewayTransaction.updating);
  const updateSuccess = useAppSelector(state => state.tenantGatewayTransaction.updateSuccess);
  const transactionCategoryValues = Object.keys(TransactionCategory);

  const handleClose = () => {
    navigate(`/tenant-gateway-transaction${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTenantPaymentGateways({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.amount !== undefined && typeof values.amount !== 'number') {
      values.amount = Number(values.amount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tenantGatewayTransactionEntity,
      ...values,
      gateway: tenantPaymentGateways.find(it => it.id.toString() === values.gateway?.toString()),
      paymentMode: clinicalDictionaries.find(it => it.id.toString() === values.paymentMode?.toString()),
      paymentState: clinicalDictionaries.find(it => it.id.toString() === values.paymentState?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          transactionType: 'DB',
          ...tenantGatewayTransactionEntity,
          gateway: tenantGatewayTransactionEntity?.gateway?.id,
          paymentMode: tenantGatewayTransactionEntity?.paymentMode?.id,
          paymentState: tenantGatewayTransactionEntity?.paymentState?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tenantGatewayTransaction.home.createOrEditLabel" data-cy="TenantGatewayTransactionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.home.createOrEditLabel">
              Create or edit a TenantGatewayTransaction
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tenant-gateway-transaction-id"
                  label={translate('tinyMedicRestApp.tenantGatewayTransaction.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.success')}
                id="tenant-gateway-transaction-success"
                name="success"
                data-cy="success"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="successLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.success" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.code')}
                id="tenant-gateway-transaction-code"
                name="code"
                data-cy="code"
                type="text"
              />
              <UncontrolledTooltip target="codeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.code" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.message')}
                id="tenant-gateway-transaction-message"
                name="message"
                data-cy="message"
                type="text"
              />
              <UncontrolledTooltip target="messageLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.message" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.transactionId')}
                id="tenant-gateway-transaction-transactionId"
                name="transactionId"
                data-cy="transactionId"
                type="text"
              />
              <UncontrolledTooltip target="transactionIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.transactionId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.transactionType')}
                id="tenant-gateway-transaction-transactionType"
                name="transactionType"
                data-cy="transactionType"
                type="select"
              >
                {transactionCategoryValues.map(transactionCategory => (
                  <option value={transactionCategory} key={transactionCategory}>
                    {translate(`tinyMedicRestApp.TransactionCategory.${transactionCategory}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="transactionTypeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.transactionType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.merchantId')}
                id="tenant-gateway-transaction-merchantId"
                name="merchantId"
                data-cy="merchantId"
                type="text"
              />
              <UncontrolledTooltip target="merchantIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.merchantId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.providerReferenceId')}
                id="tenant-gateway-transaction-providerReferenceId"
                name="providerReferenceId"
                data-cy="providerReferenceId"
                type="text"
              />
              <UncontrolledTooltip target="providerReferenceIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.providerReferenceId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.amount')}
                id="tenant-gateway-transaction-amount"
                name="amount"
                data-cy="amount"
                type="text"
              />
              <UncontrolledTooltip target="amountLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.amount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.payResponseCode')}
                id="tenant-gateway-transaction-payResponseCode"
                name="payResponseCode"
                data-cy="payResponseCode"
                type="text"
              />
              <UncontrolledTooltip target="payResponseCodeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.payResponseCode" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.trdPtyUtr')}
                id="tenant-gateway-transaction-trdPtyUtr"
                name="trdPtyUtr"
                data-cy="trdPtyUtr"
                type="text"
              />
              <UncontrolledTooltip target="trdPtyUtrLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.trdPtyUtr" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.qrCodeId')}
                id="tenant-gateway-transaction-qrCodeId"
                name="qrCodeId"
                data-cy="qrCodeId"
                type="text"
              />
              <UncontrolledTooltip target="qrCodeIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.qrCodeId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.storeId')}
                id="tenant-gateway-transaction-storeId"
                name="storeId"
                data-cy="storeId"
                type="text"
              />
              <UncontrolledTooltip target="storeIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.storeId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.terminalId')}
                id="tenant-gateway-transaction-terminalId"
                name="terminalId"
                data-cy="terminalId"
                type="text"
              />
              <UncontrolledTooltip target="terminalIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.terminalId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.userId')}
                id="tenant-gateway-transaction-userId"
                name="userId"
                data-cy="userId"
                type="text"
              />
              <UncontrolledTooltip target="userIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.userId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.gatewayResponse')}
                id="tenant-gateway-transaction-gatewayResponse"
                name="gatewayResponse"
                data-cy="gatewayResponse"
                type="text"
              />
              <UncontrolledTooltip target="gatewayResponseLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.gatewayResponse" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.tenantId')}
                id="tenant-gateway-transaction-tenantId"
                name="tenantId"
                data-cy="tenantId"
                type="text"
              />
              <UncontrolledTooltip target="tenantIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.tenantId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.active')}
                id="tenant-gateway-transaction-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.draft')}
                id="tenant-gateway-transaction-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="draftLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.draft" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.cursor')}
                id="tenant-gateway-transaction-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.lastUpdated')}
                id="tenant-gateway-transaction-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.microSec')}
                id="tenant-gateway-transaction-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.timestampEntry')}
                id="tenant-gateway-transaction-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.bankId')}
                id="tenant-gateway-transaction-bankId"
                name="bankId"
                data-cy="bankId"
                type="text"
              />
              <UncontrolledTooltip target="bankIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.bankId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.bankTransactionId')}
                id="tenant-gateway-transaction-bankTransactionId"
                name="bankTransactionId"
                data-cy="bankTransactionId"
                type="text"
              />
              <UncontrolledTooltip target="bankTransactionIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.bankTransactionId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.pgTransactionId')}
                id="tenant-gateway-transaction-pgTransactionId"
                name="pgTransactionId"
                data-cy="pgTransactionId"
                type="text"
              />
              <UncontrolledTooltip target="pgTransactionIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.pgTransactionId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.pgInstrumentType')}
                id="tenant-gateway-transaction-pgInstrumentType"
                name="pgInstrumentType"
                data-cy="pgInstrumentType"
                type="text"
              />
              <UncontrolledTooltip target="pgInstrumentTypeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.help.pgInstrumentType" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tenant-gateway-transaction-gateway"
                name="gateway"
                data-cy="gateway"
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.gateway')}
                type="select"
              >
                <option value="" key="0" />
                {tenantPaymentGateways
                  ? tenantPaymentGateways.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tenant-gateway-transaction-paymentMode"
                name="paymentMode"
                data-cy="paymentMode"
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.paymentMode')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tenant-gateway-transaction-paymentState"
                name="paymentState"
                data-cy="paymentState"
                label={translate('tinyMedicRestApp.tenantGatewayTransaction.paymentState')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tenant-gateway-transaction" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TenantGatewayTransactionUpdate;
